import { PageHeadProps } from "../../../ui/organisms/PageHead"

export const toPageHeadProps = (item: any): PageHeadProps => ({
  caption: item.caption,
  subtitle: item.subtitle,
  title: item.title,
  align: item.align,
})
